import {
  Box,
  Checkbox,
  Collapse,
  Group,
  LoadingOverlay,
  Stack,
  Text,
} from "@mantine/core"
import { Card, DocumentUploader } from "@tfg/ui"
import { Dispatch, SetStateAction, useState } from "react"
import { useTranslation } from "react-i18next"

import { InlineBanner } from "~/components/InlineBanner"
import { ErrorPreview } from "~/pages/Admin/Ingestion/ProductImport/components/ErrorPreview"
import { useValidateOperationsFileMutation } from "~/pages/Admin/Ingestion/ProductImport/hooks/useValidateOperationsFileMutation"
import { ErrorLogs } from "~/pages/Admin/Ingestion/ProductImport/hooks/useVerifyProductImportMutation"

type Props = {
  form: any
  clientEmail: string
  setFileErrors: Dispatch<SetStateAction<ErrorLogs | undefined>>
  fileErrors: ErrorLogs | undefined
}

export function UploadOperationsForm({
  form,
  setFileErrors,
  fileErrors,
  clientEmail,
}: Props) {
  const { t } = useTranslation()
  const [isValidFile, setIsValidFile] = useState<boolean>(false)
  const [operationUploadsChecked, setOperationUploadsChecked] =
    useState<boolean>(false)
  const { mutate: validateFile, isLoading: isValidating } =
    useValidateOperationsFileMutation({
      onError: (error) => {
        if (error.response) {
          if (error.response.status === 500) {
            setFileErrors({
              title: error.message,
              content: { error: `${error?.response?.data}` },
            })
          } else if (error.response.status === 400 && error?.response?.data) {
            if (error.response.data?.content) {
              setFileErrors(error?.response?.data)
            }
          }
        }
      },
      onSuccess: () => {
        setIsValidFile(true)
      },
    })

  const handleDrop = (files: File[]) => {
    form.setValues({ ...form.values, file: files[0] })
    setFileErrors(undefined)
    validateFile({ file: files[0], clientEmail })
  }
  return (
    <>
      <Card>
        <Stack>
          <LoadingOverlay visible={isValidating} overlayProps={{ blur: 1 }} />
          <Checkbox
            label="Do you want to upload operations for an Ingestion A Facon?"
            checked={operationUploadsChecked}
            onChange={() => {
              setFileErrors(undefined)
              setIsValidFile(false)
              form.setValues({ ...form.values, file: null })
              setOperationUploadsChecked(!operationUploadsChecked)
            }}
          />
          <Collapse in={operationUploadsChecked}>
            <Box py="sm">
              <Group pb="xs">
                {!form.isValid("email") ? (
                  <Text c="red">
                    Please select an inviter email to upload and validate an
                    operations file
                  </Text>
                ) : !isValidFile ? (
                  <Text>
                    Please upload operations excel file and check that there are
                    no errors
                  </Text>
                ) : null}
              </Group>
              {!form.values.file || fileErrors?.content ? (
                <DocumentUploader
                  onDrop={handleDrop}
                  isLoading={isValidating}
                  accept={["text/csv"]}
                  disabled={!form.isValid("email")}
                  maxFiles={1}
                  title={t("documentUpload.title")}
                  helpText={t("documentUpload.helptext")}
                />
              ) : isValidFile ? (
                <Stack>
                  <InlineBanner
                    type="success"
                    message="File valid, please proceed to launch traceability"
                    closable={false}
                  >
                    <Text fs="italic">{form.values.file.name}</Text>
                  </InlineBanner>
                </Stack>
              ) : null}
            </Box>
          </Collapse>
        </Stack>
      </Card>
      {fileErrors?.content && <ErrorPreview errorLogs={fileErrors} />}
    </>
  )
}
